import { useState, type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, buttonVariants } from '@/components/ui';
import { PassageOffreComplete } from '@/components/PassageOffreComplete';
import { PAGE_TITLES } from '@/components/layout/navigation';
import { OFFRE_COMPLETE, prixParPeriode } from '@/lib/tarifs';

/**
 * Ce qu'un compte en formule Retenue voit à la place d'une rubrique de l'offre
 * complète. La page elle-même n'est pas montée : aucun appel ne part vers le serveur.
 */
export function OffreCompleteRequise(): ReactNode {
    const { pathname } = useLocation();
    const rubrique = PAGE_TITLES[`/${pathname.split('/')[1] ?? ''}`];
    const [choixOuvert, setChoixOuvert] = useState(false);

    return (
        <div className="max-w-xl mx-auto mt-4 lg:mt-10 bg-white dark:bg-[#1E293B] border border-[#E2E8F0] dark:border-[#334155] rounded-xl p-6 lg:p-8">
            {rubrique && (
                <p className="text-xs font-semibold uppercase tracking-wider text-[#64748B] dark:text-[#94A3B8]">{rubrique}</p>
            )}
            <h2 className="mt-2 text-xl font-semibold text-[#1E293B] dark:text-[#F1F5F9]">Disponible avec l'offre complète</h2>
            <p className="mt-3 text-sm text-[#475569] dark:text-[#CBD5E1]">
                Votre formule Retenue couvre le suivi de vos retenues de garantie : échéances, alertes, point mensuel, lettre de réclamation et libération. Les devis, les factures, la trésorerie, les dépenses et l'export comptable font partie de l'offre complète.
            </p>
            <p className="mt-3 text-sm text-[#475569] dark:text-[#CBD5E1]">
                En passant à l'offre complète, vous gardez tout : vos retenues, vos clients et vos réglages.
            </p>

            {choixOuvert ? (
                <div className="mt-6">
                    <PassageOffreComplete onAnnuler={() => setChoixOuvert(false)} />
                </div>
            ) : (
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <Button onClick={() => setChoixOuvert(true)}>Passer à l'offre complète</Button>
                    <Link to="/retentions" className={buttonVariants({ variant: 'outline' })}>
                        Revenir à mes retenues
                    </Link>
                </div>
            )}

            <p className="mt-4 text-xs text-[#64748B] dark:text-[#94A3B8]">
                {`${prixParPeriode(OFFRE_COMPLETE.mensuel, 'mois')}, ou ${prixParPeriode(OFFRE_COMPLETE.annuel, 'an')}. TVA non applicable, art. 293 B du CGI.`}
            </p>
        </div>
    );
}
